import { RootState } from 'src/store';

export const getNotifications = (state: RootState) =>
  state.navbar.notificationNudge.notifications;

export const getNotificationFilters = (state: RootState) =>
  state.navbar.notificationNudge.notificationFilter;

export const getSuggestions = (state: RootState) =>
  state.navbar.suggestionNudge.suggestions;

export const getSearchResults = (state: RootState) =>
  state.navbar.search.results;

export const getSearchWorkflowSummary = (state: RootState) =>
  state.navbar.search.workflowSummary;

export const getSearchError = (state: RootState) => state.navbar.search.error;

export const getSearchLoading = (state: RootState) =>
  state.navbar.search.loading;

export const getSelectedModule = (state: RootState) => state.navbar.module;

export const getCalendarTokens = (state: RootState) =>
  state.navbar.calendarToken;

export const getSuperSetDetails = (state: RootState) =>
  state.navbar.superSetDetails;
